import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { CTA } from 'atoms/Typography/Typography';
import { ISelect, LabelPositions, SelectPosition } from './types';
import styles from './Select.module.css';

/** forwardRef- fix react refs error */
export const Select = forwardRef<HTMLLabelElement, ISelect>(
  (
    {
      options,
      label,
      className = '',
      value,
      classes,
      style,
      hasError,
      customBackground = false,
      selectPosition = SelectPosition.RIGHT,
      labelPosition = LabelPositions.LEFT,
      hideLabel = false,
      ...props
    },
    ref,
  ) => {
    return (
      <label
        className={clsx(
          styles.root,
          styles[`rootLabelPosition-${labelPosition}`],
          styles[`rootSelectPosition-${selectPosition}`],
          className,
          classes?.root,
          hasError && styles.error,
          customBackground && styles.customBackground,
          !label && styles.withoutLabel,
        )}
        ref={ref}
        htmlFor={label}
      >
        {label && !hideLabel && (
          <CTA type="md" className={styles.label}>
            {label}
          </CTA>
        )}
        <select
          className={clsx(styles.select, classes?.select)}
          value={value}
          style={style}
          id={label}
          {...props}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value} disabled={option.disabled}>
              {option.label}
            </option>
          ))}
        </select>

        <Icon type={IconType.arrowDown} className={styles.arrow} />
      </label>
    );
  },
);
